import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 12px;
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
    font-family: inherit;
    font-size: 20px;
    color: #abb2bf;
  }

  .toolbar {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
  }

  .btn {
    padding: 5px 12px;
    background: #2c313a;
    color: #abb2bf;
    border: 1px solid #3e4451;
    cursor: pointer;
    font-size: 18px;
    border-radius: 3px;
    font-family: inherit;
  }

  .section-heading {
    margin: 16px 0 6px;
    font-size: 15px;
    color: #528bff;
    text-transform: uppercase;
    letter-spacing: 1.4px;
    font-weight: 700;
  }

  .row {
    display: grid;
    grid-template-columns: 140px 1fr;
    align-items: baseline;
    gap: 10px;
    padding: 6px 10px;
    border-bottom: 1px solid #2c313a;
  }

  .row-label {
    font-size: 16px;
    color: #5c6370;
    white-space: nowrap;
  }

  .row-value {
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 18px;
    color: #abb2bf;
    word-break: break-all;
  }

  .row-value--truncated {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .copy-btn {
    padding: 2px 8px;
    background: #2c313a;
    color: #5c6370;
    border: 1px solid #3e4451;
    border-radius: 3px;
    cursor: pointer;
    font-size: 14px;
    font-family: inherit;
    flex-shrink: 0;
  }

  .copy-btn:hover {
    color: #abb2bf;
  }

  .roles {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  .role-badge {
    padding: 2px 8px;
    background: #2c313a;
    border: 1px solid #3e4451;
    border-radius: 3px;
    font-size: 15px;
    color: #abb2bf;
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
  }

  .impersonation-banner {
    padding: 8px 10px;
    background: #2c313a;
    border-left: 3px solid #e5c07b;
    color: #e5c07b;
    font-size: 17px;
    margin-bottom: 8px;
  }

  .empty {
    padding: 16px;
    color: #5c6370;
    font-size: 20px;
  }
`;
